import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_post_time_context = _resolveComponent("post-time-context")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { style: {"min-height":"40px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar_title, { class: "text-subtitle1 text-grey-7" }, {
        default: _withCtx(() => [
          _createElementVNode("small", null, [
            _createVNode(_component_humanize_time, {
              time: _ctx.post.postedAt
            }, null, 8, ["time"])
          ]),
          (_ctx.isArchived)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "orange",
                label: "Archived",
                class: "q-ml-sm"
              }))
            : _createCommentVNode("", true),
          (_ctx.isTrashed)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 1,
                color: "red",
                label: "Trashed",
                class: "q-ml-sm"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_post_time_context, {
        "date-of-loss": _ctx.dateOfLoss,
        "posted-at": _ctx.post.postedAt
      }, null, 8, ["date-of-loss", "posted-at"])
    ]),
    _: 1
  }))
}